"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("@otpusk/apisearch-toolbox/dist/queries/constants");
var _localization = _interopRequireDefault(require("../../../../localization"));
var _html = require("../../../../helpers/html");
var _Select = _interopRequireWildcard(require("../../../ui/Select"));
var _withProps = _interopRequireDefault(require("./withProps"));
var _bus = _interopRequireDefault(require("./img/bus.svg"));
var _train = _interopRequireDefault(require("./img/train.svg"));
var _plane = _interopRequireDefault(require("./img/plane.svg"));
var _no = _interopRequireDefault(require("./img/no.svg"));
var _walk = _interopRequireDefault(require("./img/walk.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var createIconEntity = function createIconEntity(element, title) {
  return {
    element: element,
    title: title
  };
};
var createValueEntity = function createValueEntity(departureID, transport) {
  return {
    departureID: departureID,
    transport: transport
  };
};
var createIconTitle = function createIconTitle(transportCode) {
  return _localization.default.t("SEARCH_FORM:TRANSPORT_".concat(R.toUpper(transportCode), "_OPTION_ICON_TITLE"));
};
var createItemContent = function createItemContent(departureName) {
  return (0, _html.decodeHTMLEntities)(_localization.default.t('SEARCH_FORM:DEPARTURE_CONTROL_OPTION_PREFIX', {
    departureName: departureName
  }));
};
var createCountryKey = JSON.stringify;
var parseCountryKey = JSON.parse;
var TRANSPORT_NO = 'no';
var TRANSPORT_ICONS = {
  air: _plane.default,
  bus: _bus.default,
  train: _train.default,
  no: _no.default
};
var EMPTY_OPTION = {
  get content() {
    return _localization.default.t('SEARCH_FORM:TRANSPORT_EMPTY_OPTION_CONTENT');
  },
  icon: createIconEntity(_walk.default),
  value: createValueEntity(_constants.EMPTY_DEPARTURE_VALUE, TRANSPORT_NO)
};
var mapTransportItem = function mapTransportItem(transportItem) {
  var id = transportItem.id,
    names = transportItem.names,
    transports = transportItem.transports;
  var commonItemProps = {
    content: createItemContent(names.rd),
    _original: transportItem
  };
  return R.isEmpty(transports) ? R.mergeAll([commonItemProps, {
    icon: createIconEntity(TRANSPORT_ICONS[TRANSPORT_NO], createIconTitle(TRANSPORT_NO)),
    value: createValueEntity(id, TRANSPORT_NO)
  }]) : R.map(function (transport) {
    return R.mergeAll([commonItemProps, {
      icon: createIconEntity(TRANSPORT_ICONS[transport], createIconTitle(transport)),
      value: createValueEntity(id, transport)
    }]);
  }, transports);
};
var searchMethod = function searchMethod(searchString, item) {
  var _original = item._original;
  if (_original) {
    var analazingNames = R.map(R.toLower, [_original.name, _original.names.rd, _original.country.name]);
    return R.any(R.startsWith(R.toLower(searchString)), analazingNames);
  }
  return false;
};
var DepartureControl = function DepartureControl(_ref) {
  var cities = _ref.cities,
    hasError = _ref.hasError,
    isMaxSizeOfValues = _ref.isMaxSizeOfValues,
    value = _ref.value,
    onChange = _ref.onChange,
    onRemove = _ref.onRemove;
  var _useTranslation = (0, _reactI18next.useTranslation)('SEARCH_FORM'),
    t = _useTranslation.t;
  var items = (0, _react.useMemo)(function () {
    var groupedByCountry = R.groupBy(function (_ref2) {
      var country = _ref2.country;
      return createCountryKey(country);
    }, cities);
    return R.prepend(EMPTY_OPTION, R.call(R.pipe(R.keys, R.map(function (countryKey) {
      return {
        content: parseCountryKey(countryKey).name,
        divider: false,
        subItems: R.call(R.pipe(R.map(mapTransportItem), R.flatten, R.sort(function (itemA, itemB) {
          return itemA.content.localeCompare(itemB.content);
        })), groupedByCountry[countryKey])
      };
    }), R.sort(function (itemA, itemB) {
      return itemA.content.localeCompare(itemB.content);
    })), groupedByCountry));
  }, [cities]);
  var itemsWithDisabled = (0, _react.useMemo)(function () {
    return R.cond([[R.always(isMaxSizeOfValues), function () {
      return R.map(R.ifElse(R.has('subItems'), R.over(R.lensProp('subItems'), R.map(function (item) {
        return R.assoc('disabled', R.all(function (own) {
          return !R.equals(own, item.value);
        }, value), item);
      })), R.assoc('disabled', true)), items);
    }], [function () {
      return R.any(function (own) {
        return R.equals(own, EMPTY_OPTION.value);
      }, value);
    }, function () {
      return R.map(R.over(R.lensProp('subItems'), function (subItems) {
        return subItems ? R.map(function (item) {
          return R.assoc('disabled', true, item);
        }, subItems) : undefined;
      }), items);
    }], [function () {
      return R.any(function (own) {
        return !R.equals(own, EMPTY_OPTION.value);
      }, value);
    }, function () {
      return R.assocPath([0, 'disabled'], true, items);
    }], [R.T, R.always(undefined)]])();
  }, [isMaxSizeOfValues, items, value]);
  return /*#__PURE__*/_react.default.createElement(_Select.default, {
    multiple: true,
    hasError: hasError,
    itemComponent: _Select.CheckboxItem,
    itemGroupComponent: _Select.CheckboxItemGroup,
    items: itemsWithDisabled || items,
    label: t('DEPARTURE_CONTROL_LABEL'),
    search: searchMethod,
    value: value,
    onChange: onChange,
    onRemove: onRemove
  });
};
DepartureControl.propTypes = {
  cities: _propTypes.default.arrayOf(_propTypes.default.shape({
    country: _propTypes.default.shape({
      id: _propTypes.default.number.isRequired,
      name: _propTypes.default.string.isRequired
    }),
    id: _propTypes.default.number.isRequired,
    name: _propTypes.default.string.isRequired,
    transports: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
  })).isRequired,
  isMaxSizeOfValues: _propTypes.default.bool.isRequired,
  hasError: _propTypes.default.bool,
  value: _propTypes.default.arrayOf(_propTypes.default.shape({
    departureID: _propTypes.default.number.isRequired,
    transport: _propTypes.default.string.isRequired
  })).isRequired,
  onChange: _propTypes.default.func.isRequired,
  onRemove: _propTypes.default.func.isRequired
};
var enhancer = R.compose(_withProps.default, _react.memo);
var _default = exports.default = enhancer(DepartureControl);